/**
 * Calls exclusively used for the contribute to report feature
 */
import {
  addContributeToReportNotification,
  deleteContributeNotifications,
} from '../../../../api/activity';
import {
  SECTION_ASSIGN_ACTION,
  SECTION_COMPLETE_ACTION,
  CONTRIBUTE_REPORT_NOTIFICATION_TYPE,
} from '../../../../constants/contributeToReport';
import { ctrContributorMarkSection } from '../../../../api/reports';
import { translate } from '../../../../i18next';

const EXPIRED_TOKEN_STATUSES = [400, 401];

/**
 * Sends a custom notification to the user assigned as task
 * @param {Object} selectedForm session form
 * @param {Number} senderId active submitterId
 * @param {Number} receiverId user assigned a section
 */
export function sendAssignTaskNotification(selectedForm, senderId, receiverId) {
  const {
    meta: { formNumber },
    data: { __users: users },
  } = selectedForm;
  const submitterName = users[senderId].fullName;
  addContributeToReportNotification(senderId, {
    title: `${submitterName} assigned you as a contributor of ${formNumber}. Please complete your section`,
    body: `${submitterName} assigned you as a contributor of ${formNumber}. Please complete your section`,
    data: { formId: selectedForm.meta.id, submitterId: senderId },
    action: SECTION_ASSIGN_ACTION,
    new: true,
    seen: null,
    actionItem: true,
    userId: receiverId,
    agencyId: null,
    isDismissable: false,
    type: CONTRIBUTE_REPORT_NOTIFICATION_TYPE,
  });
}

/**
 * Deletes the last notification for user section-assign by form i
 * @param {Number} receiverId user which notification will be updated
 * @param {Number} formId formId which notification will be updated
 */
export function removeAssignTaskNotification(receiverId, formId) {
  return deleteContributeNotifications(receiverId, formId);
}

/**
 * Sends a custom notification to submitter when a section is completed
 * @param {Object} selectedForm session form
 * @param {Number} completedById user that completed the section
 */
export function sendSectionCompleteNotification(selectedForm, completedById) {
  const {
    meta: { formNumber, formType, submitterId },
    data: { __users: users },
  } = selectedForm;
  const contributorName = users[completedById].fullName;
  addContributeToReportNotification(submitterId, {
    title: `${contributorName} completed their section of ${formType} ${formNumber}`,
    body: `${contributorName} completed their section of ${formType} ${formNumber}`,
    data: { formId: selectedForm.meta.id, submitterId },
    action: SECTION_COMPLETE_ACTION,
    new: true,
    seen: null,
    actionItem: true,
    userId: submitterId,
    agencyId: null,
    isDismissable: false,
    type: CONTRIBUTE_REPORT_NOTIFICATION_TYPE,
  });
}

async function getIsExpiredToken(e, response) {
  if (e && e.status && EXPIRED_TOKEN_STATUSES.includes(e.status)) {
    if (e.status === 400 && response) {
      return response?.errors?.[0]?.message?.includes('Access Denied');
    }
    return true;
  }
  return false;
}

/**
 * Sends an attempt to set a section complete/incomplete
 * It will return true when the requests ends successfully false otherwise
 * @param {Object} requestProps
 * @param {Object} requestData
 * @param {Object} errCb
 * @returns {Boolean}
 */
export async function sendCompleteOrIncompleteRequest(
  requestProps,
  requestData,
  errCb
) {
  try {
    await ctrContributorMarkSection(requestProps, requestData);
    return true;
  } catch (e) {
    let message;
    const response = e?.response?.json ? await e.response.json() : null;

    const isExpiredToken = await getIsExpiredToken(e, response);
    if (e && e.status && e.status === 500) {
      message = translate(
        'containers.reports.reportViewer.markCtrSection.failServerError'
      );
    } else if (isExpiredToken) {
      message = translate(
        'containers.reports.reportViewer.markCtrSection.failExpiredToken'
      );
    } else {
      message = translate(
        'containers.reports.reportViewer.markCtrSection.failDefault'
      );
    }
    if (response) {
      message = response.message || message;
    }
    errCb(message);
    return false;
  }
}
